import { getPhoneNumber } from "@miplatform/utils";

const formatFileName = (fileName) => {
  if (fileName.length < 16) {
    return fileName;
  }

  const fileType = fileName.includes(".")
    ? fileName.substring(fileName.lastIndexOf("."))
    : ".";

  return `${fileName.substring(0, 14)}..${fileType}`;
};

export const getOneLineAddress = (address) =>
  address
    ? `${address.addressLine1}, ${address.city}, ${address.regionCode} ${address.postalCode}`
    : "--";

export const getAttachmentsFromDocuments = (documents, rootUrl) =>
  documents.map(({ referenceId, metadata }) => ({
    fileName: metadata?.title || "Untitled",
    url: `${rootUrl}/${referenceId}`,
  }));

export const getAttachmentsFromFiles = (files) => {
  if (!Array.isArray(files)) return [];

  return files.map((file) => ({
    fileName: formatFileName(file.name),
    url: URL.createObjectURL(file),
  }));
};

export const getContactInformationFromUser = (user) => {
  const title = user.roles?.[0]?.name;

  return `${user.firstName} ${user.lastName}\n${title ? `${title}\n` : ""}${
    user.email
  }${
    user.primaryPhoneNumber
      ? `\n${getPhoneNumber(user.primaryPhoneNumber)}`
      : ""
  }`;
};

export const getContactInformation = (user) =>
  `Please feel free to reach out if you have any questions. Thank you! \n\n${getContactInformationFromUser(
    user
  )}`;

export const getRecipientName = (recipients) => {
  if (!recipients) {
    return "Hello";
  }

  if (recipients?.length > 1) {
    return "Dear All";
  }

  if (!recipients[0]?.name || recipients[0]?.name.includes("@")) {
    return "Hello";
  }

  return `Dear ${recipients[0].name}`;
};

export const updateRecipientName = (details, recipients) => {
  const greeting = getRecipientName(recipients);

  const bodyWithoutFirstLine = details.includes("\n")
    ? details.substring(details.indexOf("\n") + 1)
    : "";

  return `${greeting},\n${bodyWithoutFirstLine}`;
};
